"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheTemporaryQueryView = exports.cacheTemporaryView = exports.updateMirror = exports.updateMirrorName = exports.deactivateMirrorCollaborator = exports.activeMirrorCollaborator = exports.setMirrorClient = exports.resetMirror = exports.setMirror = exports.setMirrorLoading = exports.setMirrorSaveStatus = exports.setMirrorErrorCode = exports.fetchMirrorPack = exports.fetchMirrorDataPackApi = exports.fetchMirrorInfoApi = void 0;
const selectors_1 = require("../../../../../../exports/store/selectors");
const catalog_tree_1 = require("../../../../../../modules/space/store/actions/catalog_tree");
const config_1 = require("../../../../../../config");
const mirror_api_1 = require("../../../../api/mirror_api");
const store_1 = require("../../../../../../exports/store");
const redux_batched_actions_1 = require("redux-batched-actions");
const action_constants_1 = require("../../../../../../modules/shared/store/action_constants");
const datasheet_1 = require("../../../../../../modules/database/store/actions/resource/datasheet");
const store2_1 = __importDefault(require("store2"));
const fetchMirrorInfoApi = (mirrorId, shareId, _templateId) => {
    let requestMethod = mirror_api_1.fetchMirrorInfo;
    if (shareId) {
        requestMethod = () => (0, mirror_api_1.fetchShareMirrorInfo)(shareId, mirrorId);
    }
    return requestMethod(mirrorId);
};
exports.fetchMirrorInfoApi = fetchMirrorInfoApi;
const fetchMirrorDataPackApi = (mirrorId, shareId, recordIds, filterInfo) => {
    let requestMethod = mirror_api_1.fetchMirrorDataPack;
    if (shareId) {
        requestMethod = () => (0, mirror_api_1.fetchShareMirrorDataPack)(shareId, mirrorId);
    }
    return requestMethod(mirrorId, recordIds, filterInfo);
};
exports.fetchMirrorDataPackApi = fetchMirrorDataPackApi;
function fetchMirrorPack(mirrorId, successCb, _overwrite, extra, failCb) {
    return (dispatch, getState) => {
        const state = getState();
        const mirror = (0, selectors_1.getMirror)(state, mirrorId);
        const preFilterInfo = mirror === null || mirror === void 0 ? void 0 : mirror.filterInfo;
        const { shareId, templateId } = state.pageParams;
        const mirrorLoading = (0, selectors_1.getMirrorLoading)(state, mirrorId);
        let hasMirrorData = false;
        if (mirrorLoading) {
            return;
        }
        if (mirror) {
            const { datasheetId, viewId } = (0, selectors_1.getMirrorSourceInfo)(state, mirrorId);
            const datasheet = (0, selectors_1.getDatasheet)(state, datasheetId);
            if (datasheet && !datasheet.isPartOfData && datasheet.snapshot.meta.views.find(view => view.id == viewId) && (extra && preFilterInfo == extra.filterInfo))
                hasMirrorData = true;
        }
        if (!hasMirrorData) {
            return (0, exports.fetchMirrorInfoApi)(mirrorId, shareId, templateId)
                .then(response => {
                // if (!response.data.success && state.catalogTree.treeNodesMap[mirrorId]) {
                //   // dispatch(deleteNode({ nodeId: mirrorId, parentId: state.catalogTree.treeNodesMap[mirrorId].parentId }));
                //   // return Promise.reject();
                // }
                return Promise.resolve({ mirrorId, response, dispatch, getState });
            })
                .catch(e => {
                dispatch((0, exports.setMirrorErrorCode)(mirrorId, config_1.StatusCode.COMMON_ERR));
                throw e;
            })
                .then((props) => __awaiter(this, void 0, void 0, function* () {
                const { recordIds } = extra || {};
                const { filterInfo } = extra || {};
                yield fetchSuccess(props, recordIds, filterInfo, successCb, failCb);
            }));
        }
        successCb && successCb();
        return;
    };
}
exports.fetchMirrorPack = fetchMirrorPack;
const setMirrorErrorCode = (mirrorId, code) => {
    return {
        type: store_1.ActionConstants.MIRROR_ERROR_CODE,
        payload: code,
        mirrorId,
    };
};
exports.setMirrorErrorCode = setMirrorErrorCode;
const setMirrorSaveStatus = (mirrorId, code) => {
    return {
        type: store_1.ActionConstants.MIRROR_SAVE_STATUS,
        payload: code,
        mirrorId,
    };
};
exports.setMirrorSaveStatus = setMirrorSaveStatus;
const fetchSuccess = ({ dispatch, getState, response, mirrorId }, recordIds, filterInfo, successCb, failCb) => {
    var _a;
    const { data, success, code } = response.data;
    if (success) {
        const ds = store2_1.default.namespace('_temporary_view');
        const tempView = ds.get(mirrorId);
        if (tempView) {
            data.mirror.temporaryView = tempView;
            if (!filterInfo)
                filterInfo = JSON.stringify(tempView.queryFilterInfo);
        }
        const _batchActions = [
            (0, exports.setMirror)(Object.assign(Object.assign({}, data.mirror), { sourceInfo: data.sourceInfo, snapshot: data.snapshot, filterInfo: filterInfo }), data.mirror.id),
        ];
        if (!filterInfo && ((_a = data.mirror.extra) === null || _a === void 0 ? void 0 : _a.backLoadData)) { //第一次不积极加载数据，那就加载空数据吧
            recordIds = ['-1']; //
        }
        const state = getState();
        const shareId = state.pageParams.shareId;
        const sourceDatasheetId = data.sourceInfo.datasheetId;
        //const datasheet = getDatasheet(state, sourceDatasheetId);
        let hasMirrorData = false;
        //if(datasheet&&!datasheet.isPartOfData&&datasheet.snapshot.meta.views.find(view=>view.id==data.sourceInfo.viewId))
        //hasMirrorData=true;
        if (!hasMirrorData) {
            (0, exports.fetchMirrorDataPackApi)(mirrorId, shareId, recordIds, filterInfo)
                .then(response => {
                let isPartOfData = false;
                if (recordIds && (recordIds[0] == '-1' || recordIds.length == 0)) {
                    isPartOfData = false;
                }
                else {
                    isPartOfData = Boolean(recordIds);
                }
                return Promise.resolve({
                    datasheetId: sourceDatasheetId,
                    responseBody: response.data,
                    dispatch,
                    getState,
                    isPartOfData: isPartOfData,
                    forceFetch: true
                });
            })
                .catch(e => {
                if (state.catalogTree.treeNodesMap[sourceDatasheetId]) {
                    dispatch((0, catalog_tree_1.deleteNode)({ nodeId: sourceDatasheetId, parentId: state.catalogTree.treeNodesMap[sourceDatasheetId].parentId }));
                }
                dispatch((0, datasheet_1.datasheetErrorCode)(sourceDatasheetId, config_1.StatusCode.COMMON_ERR));
                throw e;
            })
                .then(props => {
                (0, datasheet_1.fetchDatasheetPackSuccess)(props);
                props.responseBody.success ? successCb && successCb() : failCb && failCb();
            }, e => {
                console.error('fetchMirrorDataPackApi error', e);
            });
        }
        else {
            successCb && successCb();
        }
        dispatch((0, redux_batched_actions_1.batchActions)(_batchActions));
        return;
    }
    dispatch((0, exports.setMirrorErrorCode)(mirrorId, code));
    failCb && failCb();
};
const setMirrorLoading = (status, mirrorId) => {
    return {
        type: store_1.ActionConstants.SET_MIRROR_LOADING,
        payload: status,
        mirrorId: mirrorId,
    };
};
exports.setMirrorLoading = setMirrorLoading;
const setMirror = (data, mirrorId) => {
    return {
        type: store_1.ActionConstants.SET_MIRROR_DATA,
        payload: data,
        mirrorId: mirrorId,
    };
};
exports.setMirror = setMirror;
const resetMirror = (mirrorId) => {
    return {
        type: store_1.ActionConstants.RESET_MIRROR,
        mirrorId: mirrorId,
    };
};
exports.resetMirror = resetMirror;
const setMirrorClient = (client) => {
    return {
        type: store_1.ActionConstants.SET_MIRROR_CLIENT,
        payload: client,
    };
};
exports.setMirrorClient = setMirrorClient;
const activeMirrorCollaborator = (payload, resourceId) => {
    return {
        type: store_1.ActionConstants.MIRROR_ACTIVE_COLLABORATOR,
        mirrorId: resourceId,
        payload,
    };
};
exports.activeMirrorCollaborator = activeMirrorCollaborator;
const deactivateMirrorCollaborator = (payload, resourceId) => {
    return {
        type: store_1.ActionConstants.MIRROR_DEACTIVATE_COLLABORATOR,
        mirrorId: resourceId,
        payload,
    };
};
exports.deactivateMirrorCollaborator = deactivateMirrorCollaborator;
const updateMirrorName = (newName, mirrorId) => {
    return {
        type: action_constants_1.UPDATE_MIRROR_NAME,
        mirrorId,
        payload: newName,
    };
};
exports.updateMirrorName = updateMirrorName;
const updateMirror = (mirrorId, data) => {
    return {
        type: action_constants_1.UPDATE_MIRROR_INFO,
        mirrorId,
        payload: data,
    };
};
exports.updateMirror = updateMirror;
const cacheTemporaryView = (viewProperty, mirrorId) => {
    return {
        type: action_constants_1.CACHE_TEMPORARY_VIEW,
        payload: viewProperty,
        mirrorId,
    };
};
exports.cacheTemporaryView = cacheTemporaryView;
const cacheTemporaryQueryView = (viewProperty, mirrorId) => {
    return {
        type: action_constants_1.CACHE_TEMPORARY_QUERY_VIEW,
        payload: viewProperty,
        mirrorId,
    };
};
exports.cacheTemporaryQueryView = cacheTemporaryQueryView;
//# sourceMappingURL=mirror.js.map